import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { AlkEvent, BaseView } from '@wizeoo/akm-common-lib';
import { FilterComponent, UploadParameter, WizAgGrid, WizDatasource, WizEvent, WizEventManager, WizGroup, WizGroupCommand, WizRoot, WizTextarea } from '@wizeoo/akm-component-lib';
import { Model } from 'src/app/model/model';
import { IaQuestionCmd } from 'src/app/cmd/ia/iaquestion.cmd'
import { APP_EVENT_TYPE } from 'src/app/model/enums';
import { Attachment } from '@wizeoo/akm-message-lib';
import { WIZ_EVENT_TYPE, WIZ_UPLOAD_ACCEPT_FORMAT } from '@wizeoo/akm-core-lib';
import { AiQuestion } from '@wizeoo/akm-message-lib';

@Component({
  selector: 'questions-view',
  templateUrl: './questions.view.html',
})
// Vue d'initialisation pour chargement du contexte
export class QuestionsView extends BaseView {

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef ) {
    super(elementRef);
  }

  /* #############################################################
                      CYCLE DE VIE
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const commands = [];
    // chargement de la liste des questions
    if (!Model.getInstance().questionMap) {
      commands.push(new IaQuestionCmd(Model.getInstance()).find());
    }

    if (commands.length > 0) {
      return new WizGroupCommand().configure(commands, null, false);
    } else {
      return null;
    }
  }

  /** Mise en place des ecouteurs de la vue */
  public wizAddListener(): void {
    super.wizAddListener(); 
  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {

    // alimentation du bread
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(APP_EVENT_TYPE.BREAD, '$.ai.questions.$'));
  }

}